// @flow
import React from 'react';

const EmptyComponent = () => <span />;

export default EmptyComponent;
